import {Injectable} from '@angular/core';
import {ProductMetadataInfo} from "../interface/product-metadata-info";
import {FilterTransmissionService} from "../../raintree/transmission/filter-transmission.service";

@Injectable({
  providedIn: 'root'
})
export class FilterCsvMetadataService {

	public static colorList: ProductMetadataInfo[] = [];
	public static materialList: ProductMetadataInfo[] = [];
	public static patternList: ProductMetadataInfo[] = [];
	constructor(
		private _api: FilterTransmissionService
	) {
	}

	public getColorList(
		onPreExecute: () => void,
		onComplete: () => void,
	): void {
		this._api.resolveColorList(
			() => {
				onPreExecute();
			},
			(response: ProductMetadataInfo[]) => {},
			(response: ProductMetadataInfo[]) => {
				FilterCsvMetadataService.colorList = response;
			},
			(error: string) => {},
			() => {
				onComplete();
			}
		);
	}

	public getPatternList(
		onPreExecute: () => void,
		onComplete: () => void,
	): void {
		this._api.resolvePatternList(
			() => {
				onPreExecute();
			},
			(response: ProductMetadataInfo[]) => {
			},
			(response: ProductMetadataInfo[]) => {
				FilterCsvMetadataService.patternList = response;
			},
			(error: string) => {
			},
			() => {
				onComplete();
			}
		);
	}
	public getMaterialList(
		onPreExecute: () => void,
		onComplete: () => void,
	): void {
		this._api.resolveMaterialList(
			() => {
				onPreExecute();
			},
			(response: ProductMetadataInfo[]) => {
			},
			(response: ProductMetadataInfo[]) => {
				FilterCsvMetadataService.materialList = response;
			},
			(error: string) => {
			},
			() => {
				onComplete();
			}
		)
	}
}
